import { defineStore } from "pinia";
import { ref } from '@nuxtjs/composition-api';
export const useScrollPositionStore = defineStore('scrollPosition', () => {
  const scrollPositions = ref<Record<string, number>>({});
  const lastRoute = ref<string>('');

  function setScrollPosition(key: string, position: number) {
    scrollPositions.value[key] = position;
  }

  function getScrollPosition(key: string): number | undefined {
    return scrollPositions.value[key];
  }

  return {
    setScrollPosition,
    getScrollPosition,
    scrollPositions,
    lastRoute
  };
});
